export default {
  isA: function (object) {
    return object.type === 'path'
  },

  scale: function (shape) {
    const options = {
      width: shape.width * shape.scaleX,
      height: shape.height * shape.scaleY,
      scaleX: 1,
      scaleY: 1,
      pathOffset: { x: 0, y: 0 },
      path: []
    }

    // find min x and y
    const min = { x: 0, y: 0 }
    shape.path.forEach((point) => {
      point.forEach((n, i) => {
        if (i > 0) {
          if (i % 2) {
            min.x = min.x ? Math.min(min.x, n) : n
          } else {
            min.y = min.y ? Math.min(min.y, n) : n
          }
        }
      })
    })

    // scale our points, normalizing for min x and y
    shape.path.forEach((point) => {
      const scaledPoint = []
      point.forEach((n, i) => {
        if (i > 0) {
          if (i % 2) {
            scaledPoint.push((n - min.x) * shape.scaleX)
          } else {
            scaledPoint.push((n - min.y) * shape.scaleY)
          }
        } else {
          scaledPoint.push(n)
        }
      })
      options.path.push(scaledPoint)
    })

    options.pathOffset.x = options.width / 2
    options.pathOffset.y = options.height / 2

    shape.set(options)
  }
}
